/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const BlockEmbed = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <rect width={24} height={18} y={3} fill="#33AFFF" rx={2} />,
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10 16.309l2.71-8.976 1.214.358-2.71 8.976L10 16.309zM8.447 14.99L5.333 11.7l3.114-3.298.886.944L7.107 11.7l2.226 2.347-.886.944zm7.107 0l-.887-.944 2.226-2.347-2.226-2.354.886-.944 3.114 3.298-3.114 3.29z"
    />,
  );
};

export default BlockEmbed;
